import { Sk, OLINGO_BARS } from './shared';

export function MkOlingo() {
  return (
    <div className="csmk csmk-olingo">
      <div className="rec-row">
        <div className="rec-meta">
          <span className="ledr" /> REC
          <span className="ts">00:02</span>
          <span className="ws">WS 16</span>
        </div>
        <div className="wave">
          {OLINGO_BARS.map((v, i) => <b key={i} style={{ transform: `scaleY(${v})` }} />)}
          <span className="cursor" />
        </div>
      </div>
      <div className="trans-row">
        <div className="tline dr">
          <span className="spk">DR.</span>
          <span className="bubble">
            <span className="shimmer" style={{ width: '94%' }} />
            <span className="shimmer" style={{ width: '66%' }} />
          </span>
        </div>
        <div className="tline patient">
          <span className="bubble">
            <span className="shimmer" style={{ width: '88%' }} />
            <span className="shimmer" style={{ width: '54%' }} />
          </span>
          <span className="spk">PATIENT</span>
        </div>
      </div>
    </div>
  );
}
